// TODO enable eslint
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-state */
/* eslint-disable eqeqeq */
import PropTypes from "prop-types"
import React, { Component } from "react"
import moment from "moment"

import { iterateTimes, getNextUnit } from "../utility/calendar"

export default class TimelineElementsHeader extends Component {
  static propTypes = {
    hasRightSidebar: PropTypes.bool.isRequired,
    showPeriod: PropTypes.func.isRequired,
    canvasTimeStart: PropTypes.number.isRequired,
    canvasTimeEnd: PropTypes.number.isRequired,
    canvasWidth: PropTypes.number.isRequired,
    minUnit: PropTypes.string.isRequired,
    timeSteps: PropTypes.object.isRequired,
    width: PropTypes.number.isRequired,
    headerLabelFormats: PropTypes.object.isRequired,
    subHeaderLabelFormats: PropTypes.object.isRequired,
    headerLabelGroupHeight: PropTypes.number.isRequired,
    headerLabelHeight: PropTypes.number.isRequired,
    registerScroll: PropTypes.func.isRequired,
    planStart: PropTypes.number,
    planEnd: PropTypes.number,
  }

  constructor(props) {
    super(props)

    props.registerScroll(scrollX => {
      if (scrollX != null) {
        this.headerEl.scrollLeft = scrollX
      }
    })
    this.state = {
      touchTarget: null,
      touchActive: false,
    }
  }

  static handleHeaderMouseDown(evt) {
    // don't bubble so that we prevent our scroll component
    // from knowing about it
    evt.stopPropagation()
  }

  headerLabel(time, unit, width) {
    const { headerLabelFormats: f } = this.props

    if (unit === `year`) {
      return time.format(width < 46 ? f.yearShort : f.yearLong)
    }
    if (unit === `month`) {
      return time.format(
        width < 65
          ? f.monthShort
          : width < 75
          ? f.monthMedium
          : width < 120
          ? f.monthMediumLong
          : f.monthLong,
      )
    }
    if (unit === `day`) {
      return time.format(width < 150 ? f.dayShort : f.dayLong)
    }
    if (unit === `hour`) {
      return time.format(
        width < 50
          ? f.hourShort
          : width < 130
          ? f.hourMedium
          : width < 150
          ? f.hourMediumLong
          : f.hourLong,
      )
    }
    return time.format(f.time)
  }

  subHeaderLabel(time, unit, width) {
    const { subHeaderLabelFormats: f } = this.props

    if (unit === `year`) {
      return time.format(width < 46 ? f.yearShort : f.yearLong)
    }
    if (unit === `month`) {
      return time.format(
        width < 37 ? f.monthShort : width < 85 ? f.monthMedium : f.monthLong,
      )
    }
    if (unit === `day`) {
      return time.format(
        width < 47
          ? f.dayShort
          : width < 80
          ? f.dayMedium
          : width < 120
          ? f.dayMediumLong
          : f.dayLong,
      )
    }
    if (unit === `hour`) {
      return time.format(width < 50 ? f.hourShort : f.hourLong)
    }
    if (unit === `minute`) {
      return time.format(width < 60 ? f.minuteShort : f.minuteLong)
    }
    return time.get(unit)
  }

  handlePeriodClick = (time, unit) => {
    if (time && unit) {
      this.props.showPeriod(moment(time - 0), unit)
    }
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.canvasTimeStart != this.props.canvasTimeStart ||
      nextProps.canvasTimeEnd != this.props.canvasTimeEnd ||
      nextProps.width != this.props.width ||
      nextProps.canvasWidth != this.props.canvasWidth ||
      nextProps.subHeaderLabelFormats != this.props.subHeaderLabelFormats ||
      nextProps.headerLabelFormats != this.props.headerLabelFormats ||
      nextProps.planStart !== this.props.planStart ||
      nextProps.planEnd !== this.props.planEnd
    )
  }

  render() {
    const {
      canvasTimeStart,
      canvasTimeEnd,
      canvasWidth,
      minUnit,
      timeSteps,
      headerLabelGroupHeight,
      headerLabelHeight,
      hasRightSidebar,
      planStart,
      planEnd,
    } = this.props

    const ratio = canvasWidth / (canvasTimeEnd - canvasTimeStart)
    const twoHeaders = minUnit !== `year`

    const topHeaderLabels = []
    // add the top header
    if (twoHeaders) {
      const nextUnit = getNextUnit(minUnit)

      iterateTimes(
        canvasTimeStart,
        canvasTimeEnd,
        nextUnit,
        timeSteps,
        (time, nextTime) => {
          const left = Math.round((time.valueOf() - canvasTimeStart) * ratio)
          const right = Math.round(
            (nextTime.valueOf() - canvasTimeStart) * ratio,
          )

          const labelWidth = right - left
          // this width applies to the content in the header
          // it simulates stickyness where the content is fixed in the center
          // of the label.  when the labelWidth is less than visible time range,
          // have label content fill the entire width
          const contentWidth = Math.min(labelWidth, canvasWidth / 3)

          topHeaderLabels.push(
            <div
              key={`top-label-${time.valueOf()}`}
              className={`rct-label-group${
                hasRightSidebar ? ` rct-has-right-sidebar` : ``
              }`}
              onClick={() => this.handlePeriodClick(time, nextUnit)}
              style={{
                left: `${left - 1}px`,
                width: `${labelWidth}px`,
                height: `${headerLabelGroupHeight}px`,
                lineHeight: `${headerLabelGroupHeight}px`,
                cursor: `pointer`,
              }}
            >
              <span style={{ width: contentWidth, display: `block` }}>
                {this.headerLabel(time, nextUnit, labelWidth)}
              </span>
            </div>,
          )
        },
      )
    }

    const bottomHeaderLabels = []
    iterateTimes(
      canvasTimeStart,
      canvasTimeEnd,
      minUnit,
      timeSteps,
      (time, nextTime) => {
        const left = (time.valueOf() - canvasTimeStart) * ratio
        const minUnitValue = time.get(minUnit === `day` ? `date` : minUnit)
        const firstOfType = minUnitValue === (minUnit === `day` ? 1 : 0)
        const labelWidth = (nextTime.valueOf() - time.valueOf()) * ratio

        const classNamesForTime = []
        if (nextTime <= planStart || time >= planEnd) {
          classNamesForTime.push(`rct-out-of-plan`)
        }

        bottomHeaderLabels.push(
          <div
            key={`label-${time.valueOf()}`}
            className={`rct-label ${twoHeaders ? `` : `rct-label-only`} ${
              firstOfType ? `rct-first-of-type` : ``
            } ${minUnit !== `month` ? `rct-day rct-day-${time.day()}` : ``}
            rct-label-${minUnit} ${classNamesForTime.join(` `)}`}
            onClick={() => this.handlePeriodClick(time, minUnit)}
            style={{
              left: `${left}px`,
              width: `${labelWidth + 1}px`,
              height: `${
                minUnit === `year`
                  ? headerLabelGroupHeight + headerLabelHeight
                  : headerLabelHeight
              }px`,
              fontSize: `${
                labelWidth > 40 ? `14` : labelWidth > 20 ? `10` : `8`
              }px`,
              cursor: `pointer`,
            }}
          >
            {this.subHeaderLabel(time, minUnit, labelWidth)}
          </div>,
        )
      },
    )

    const headerStyle = {
      height: `${headerLabelGroupHeight + headerLabelHeight}px`,
    }

    return (
      <div
        key="header"
        data-testid="header"
        className="rct-header"
        onMouseDown={TimelineElementsHeader.handleHeaderMouseDown}
        onTouchStart={this.touchStart}
        onTouchEnd={this.touchEnd}
        style={headerStyle}
        ref={el => {
          this.headerEl = el
          return el
        }}
      >
        <div
          className="top-header"
          style={{
            height: twoHeaders ? headerLabelGroupHeight : 0,
            width: canvasWidth,
          }}
        >
          {topHeaderLabels}
        </div>
        <div
          className="bottom-header"
          style={{
            height: twoHeaders
              ? headerLabelHeight
              : headerLabelHeight + headerLabelGroupHeight,
            width: canvasWidth,
          }}
        >
          {bottomHeaderLabels}
        </div>
      </div>
    )
  }
}
